import { render, staticRenderFns } from "./OMButton.vue?vue&type=template&id=59ff89e0&scoped=true"
import script from "./OMButton.vue?vue&type=script&lang=js"
export * from "./OMButton.vue?vue&type=script&lang=js"
import style0 from "./OMButton.vue?vue&type=style&index=0&id=59ff89e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../omniscient/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ff89e0",
  null
  
)

export default component.exports